/**
 * Section 5: Photo Submission - General Interior/Exterior Photos
 */

import { FileUpload } from '@ox/visits-ui/components/shared/FileUpload';

export function Section5PhotoUpload() {
  return (
    <div className="form-section">
      <h2>Photo Submission</h2>
      <div className="property-value-display">
        <a href="/guidance?checklist=photo" target="_blank"><p>📋 View full photo checklist</p></a>

        <h3>Quick reference:</h3>
        <ul>
          <li>All rooms (living, bedrooms, bathrooms, kitchen)</li>
          <li>Exterior (front, back, both sides)</li>
          <li>Major defects or damage</li>
          <li>Notable features or upgrades</li>
        </ul>
      </div>
      
      <hr className="section-divider" />

      <FileUpload
        label="HVAC - Date of Manufacture (1 Photo)"
        mediaType="photo_hvac"
        sectionNumber={5}
        accept="image/*"
        required
        helpText="Photo needs to include date of manufacture or serial number"
      />

      <FileUpload
        label="Water Heater - Date of Manufacture (1 Photo)"
        mediaType="photo_water_heater"
        sectionNumber={5}
        accept="image/*"
        required
        helpText="Photo needs to include date of manufacture or serial number"
      />

      <FileUpload
        label="Lockbox Location with Accompanying Keys (1 Photo)"
        mediaType="photo_lockbox"
        sectionNumber={5}
        accept="image/*"
        required
      />

      <FileUpload
        label="Living Area(s) (Up to 10 photos)"
        mediaType="photos_living_areas"
        sectionNumber={5}
        minFiles={2}
        maxFiles={10}
        accept="image/*"
        required
        helpText="Living rooms, Dens, Offices, Kitchen/Dining spaces"
      />

      <FileUpload
        label="Bedrooms (Up to 10 photos)"
        mediaType="photos_bedrooms"
        sectionNumber={5}
        minFiles={2}
        maxFiles={10}
        accept="image/*"
        required
      />

      <FileUpload
        label="Bathroom(s) (Up to 10 photos)"
        mediaType="photos_bathrooms"
        sectionNumber={5}
        maxFiles={10}
        accept="image/*"
        required
      />

      <FileUpload
        label="Laundry Room (1 Photo)"
        mediaType="photo_laundry_room"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
      />

      <FileUpload
        label="Gas Kitchen Range (if applicable)"
        mediaType="photo_gas_range"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
      />

      <FileUpload
        label="All Appliances (1 Photo per Appliance)"
        mediaType="photos_appliances"
        sectionNumber={5}
        minFiles={3}
        maxFiles={10}
        accept="image/*"
        required
        helpText="1 photo per appliance"
      />

      <FileUpload
        label="Shed(s) / Casita (1 Photo per, if Applicable)"
        mediaType="photos_shed_casita"
        sectionNumber={5}
        accept="image/*"
        maxFiles={5}
      />

      <FileUpload
        label="Running Water (1 Photo)"
        mediaType="photo_running_water"
        sectionNumber={5}
        accept="image/*"
        required
        helpText="If the water is off, find the water meter on the street and attempt to visually confirm whether the valve at the street meter is on or off"
      />

      <FileUpload
        label="Street Water Meter - If Water is Off (1 Photo)"
        mediaType="photo_street_water_meter"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
      />

      <FileUpload
        label="Gas Meter - If Gas is Off (1 Photo)"
        mediaType="photo_gas_meter"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
        helpText="If the gas is off, check whether it is locked off by the utility company"
      />

      <FileUpload
        label="Electric Meter - If Electric is Off (1 Photo)"
        mediaType="photo_electric_meter"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
        helpText="If the electric is off, photograph the meter and note whether service has been disconnected"
      />

      <FileUpload
        label="Rear of Property (Up to 3 Photos)"
        mediaType="photos_rear"
        sectionNumber={5}
        maxFiles={3}
        accept="image/*"
        required
      />

      <FileUpload
        label="Side(s) of Property (2 Photos)"
        mediaType="photos_sides"
        sectionNumber={5}
        minFiles={2}
        maxFiles={2}
        accept="image/*"
        required
      />

      <FileUpload
        label="Garage Interior (1 Photo)"
        mediaType="photos_garage_interior"
        sectionNumber={5}
        accept="image/*"
      />

      <FileUpload
        label="Under Deck - If Elevated (1 Photo)"
        mediaType="photo_under_deck"
        sectionNumber={5}
        accept="image/*"
      />

      <FileUpload
        label="Street View of Property Front (1 Photo)"
        mediaType="photo_street_front"
        sectionNumber={5}
        accept="image/*"
        required
      />

      <FileUpload
        label="House Number Verification (1 Photo)"
        mediaType="photo_address_verification"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
        required
        helpText="House number on fascia, mailbox, or other visible location"
      />

      <FileUpload
        label="Street Scene - Neighborhood View from Driveway (1 Photo)"
        mediaType="photo_street_scene"
        sectionNumber={5}
        maxFiles={1}
        accept="image/*"
        required
      />

      <FileUpload
        label="Roof Condition - As many angles as possible from street level (Up to 10 Photos)"
        mediaType="photos_roof"
        sectionNumber={5}
        minFiles={2}
        maxFiles={10}
        accept="image/*"
        required
        helpText="As many angles as possible"
      />

      <FileUpload
        label="Property Damage - If Any (Up to 10 Photos)"
        mediaType="photos_damage"
        sectionNumber={5}
        maxFiles={10}
        accept="image/*"
      />
    </div>
  );
}
